"use client"

import type { ReactNode } from "react"

import Image from "next/image"

import { useFieldA11y, type FieldSize, type FieldState } from "@/components/ui/field"

interface PickerFieldProps {
  label?: string
  value?: string
  placeholder: string
  state?: FieldState
  size?: FieldSize
  help?: ReactNode
  leading?: ReactNode
  disabled?: boolean
  onOpen: () => void
  id?: string
}

export const PickerField = ({ label, value, placeholder, state, size, help, leading, disabled, onOpen, id }: PickerFieldProps) => {
  const { fieldId, helpId, styles, controlProps } = useFieldA11y({ id, help, state, size, disabled })
  const labelId = `${fieldId}-label`
  const valueId = `${fieldId}-value`
  return (
    <div className={styles.root()}>
      {label && (
        <label id={labelId} htmlFor={fieldId} className={styles.label()}>
          {label}
        </label>
      )}
      <button
        type="button"
        disabled={disabled}
        onClick={onOpen}
        aria-haspopup="dialog"
        aria-labelledby={label ? `${labelId} ${valueId}` : valueId}
        {...controlProps}
        className={styles.control({ className: `flex items-center ${leading ? "gap-200" : "gap-250"} text-left outline-none enabled:cursor-pointer` })}
      >
        {leading && <span className="flex size-6 shrink-0 items-center justify-center">{leading}</span>}
        <span id={valueId} className={styles.input({ className: `self-center truncate ${value && !disabled ? "" : "text-fg-muted"}` })}>
          {value || placeholder}
        </span>
        <Image src="/images/icons/picker-chevron.svg" alt="" width={24} height={24} className="shrink-0" />
      </button>
      {help && (
        <div id={helpId} className={styles.help()}>
          {help}
        </div>
      )}
    </div>
  )
}
